import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    iss: string;
    code: string;
    scope: string;
    authuser: number;
    prompt: string;
}

const SignInWithGoogleActivity: ActivityComponentType<Params> = ({ params }: {params: Params}) => {
    const { code } = params;
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default SignInWithGoogleActivity;
